import { render, staticRenderFns } from "./Estudiantes.vue?vue&type=template&id=eb7a5a8e&scoped=true"
import script from "./Estudiantes.vue?vue&type=script&lang=js"
export * from "./Estudiantes.vue?vue&type=script&lang=js"
import style0 from "./Estudiantes.vue?vue&type=style&index=0&id=eb7a5a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7a5a8e",
  null
  
)

export default component.exports